import { Component, Input } from '@angular/core';
import { BaseStepComponent } from '../../base';
import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
@Component({
    // tslint:disable-next-line: component-selector
    selector: 'enviar-recurso',
    templateUrl: './enviar-recurso-component.html'
})
export class EnviarRecursoComponent extends BaseStepComponent {
    @Input() filtro: RecursoFiltro;
    @Input() controller: string;
    returnLink: string;

    // ['../atividades/gerenciamento-curso']
    init() {
        switch (this.controller) {
            case 'capacitadora':
                this.returnLink = '../capacitadora/gerenciamento-capacitadora/';
                break;
            case 'gerenciamento-banca':
                this.returnLink = '../atividades/gerenciamento-banca';
                break;
            case 'gerenciamento-comissao':
                this.returnLink = '../atividades/gerenciamento-comissao';
                break;
            case 'gerenciamentoCurso':
                this.returnLink = '../atividades/gerenciamento-curso';
                break;
            case 'gerenciamentoCursoExterior':
                this.returnLink = '../atividades/gerenciamento-curso-exterior';
                break;
            case 'gerenciamentoDocencia':
                this.returnLink = '../atividades/gerenciamento-docencia';
                break;
            case 'gerenciamentoEvento':
                this.returnLink = '../atividades/gerenciamento-evento';
                break;
            case 'gerenciamento-pos-graduacao':
                this.returnLink = '../atividades/gerenciamento-pos-graduacao';
                break;
            case 'gerenciamentoProducaoIntelectual':
                this.returnLink = '../atividades/gerenciamento-producao-intelectual';
                break;
            default:
                this.returnLink = null;
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/enviar-recurso/enviar-recurso.component.ts